/**
 * Errores de cara al comerciante, con el código que los cruza contra los logs.
 *
 * El backend genera un identificador corto por ocurrencia, lo escribe en el log del
 * Worker y lo devuelve en el cuerpo. Mostrarlo es lo que hace que un "se rompió algo" en
 * el chat de soporte se pueda encontrar después.
 */

import { ApiError } from './api';

export interface ErrorVisible {
  readonly mensaje: string;
  /** `null` cuando el error no llegó del backend: se cortó la red, por ejemplo. */
  readonly codigo: string | null;
  /**
   * El `code` del backend, para los pocos casos donde **no** se rompió nada.
   *
   * Un 429 por el límite de operaciones no es una falla: es un freno deliberado que
   * protege la cuota de API de la tienda. Mostrarlo en rojo bajo "Algo salió mal", con un
   * código de error y una invitación a escribir a soporte, convierte una decisión de
   * diseño en un bug a los ojos del comerciante — y nos llena soporte de tickets que no
   * tienen nada que arreglar.
   */
  readonly tipo: string | null;
}

export function aErrorVisible(excepcion: unknown, porDefecto: string): ErrorVisible {
  if (excepcion instanceof ApiError) {
    return { mensaje: excepcion.message, codigo: excepcion.id, tipo: excepcion.code };
  }
  return { mensaje: porDefecto, codigo: null, tipo: null };
}

/** Los que no son fallas: se muestran como aviso y sin código ni link a soporte. */
export function esFreno(error: ErrorVisible): boolean {
  return error.tipo === 'demasiadas_operaciones';
}
